import SyncableModel from './SyncableModel';

export default class Simulation extends SyncableModel {
  static name = 'Simulation'

  _fillable = [
    'id',
    'name',
    'user_id',
    'area',
    'total_seed',
    'started_at',
    'survival_rate',
    'size_at_100_days',
    'feed_price',
    'additional_data',
    'created_at', 'updated_at',
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    area: "float",
    total_seed: "float",
    survival_rate: "float",
    size_at_100_days: "float",
    feed_price: "float",
    additional_data: "object",
  }

  static endpoint = '/simulations'

  static online = true
}
